import { render, staticRenderFns } from "./BookTab.vue?vue&type=template&id=3b8b1169&scoped=true&"
import script from "./BookTab.vue?vue&type=script&lang=js&"
export * from "./BookTab.vue?vue&type=script&lang=js&"
import style0 from "./BookTab.vue?vue&type=style&index=0&id=3b8b1169&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b1169",
  null
  
)

export default component.exports